import { render, staticRenderFns } from "./period.vue?vue&type=template&id=bbc5367c&scoped=true"
import script from "./period.vue?vue&type=script&lang=js"
export * from "./period.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc5367c",
  null
  
)

export default component.exports